<template>
  <div id="checklistFour"></div>
</template>

<script>
export default {
  name: "ChecklistFour",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "Content Launch Checklist",
        items: [
          { text: "Write compelling headline", checked: true },
          { text: "Add visuals and graphics", checked: true },
          { text: "Proofread for errors", checked: false },
          { text: "Schedule for optimal time", checked: false },
        ],
        chip: "Checklist",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("checklistFour");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const titleSize = exporting ? 46 : 46 * this.scale;
      const itemSize = exporting ? 26 : 26 * this.scale;
      const checkSize = exporting ? 24 : 24 * this.scale;
      const logoHeight = exporting ? 42 : 42 * this.scale;
      const chipSize = exporting ? 22 : 22 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";

      const items = this.data.items || [];
      const itemsHtml = items.map((item) => `
        <div style="
          background: ${item.checked ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.4)'};
          backdrop-filter: blur(8px);
          border-radius: 12px;
          padding: 16px 20px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          ${item.checked ? 'box-shadow: 0 2px 12px rgba(61, 35, 20, 0.1);' : ''}
        ">
          <div style="
            min-width: ${checkSize}px;
            height: ${checkSize}px;
            border: 2px solid ${item.checked ? '#22c55e' : '#3d2314'};
            background: ${item.checked ? '#22c55e' : 'transparent'};
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 14px;
            flex-shrink: 0;
          ">
            ${item.checked ? `<span style="color: white; font-size: ${checkSize * 0.5}px; font-weight: bold;">✓</span>` : ''}
          </div>
          <div style="
            font-size: ${itemSize}px;
            font-weight: ${item.checked ? '600' : '400'};
            color: ${item.checked ? '#3d2314' : '#6b4423'};
            line-height: 1.3;
            ${item.checked ? '' : 'opacity: 0.7;'}
          ">${item.text}</div>
        </div>
      `).join('');

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(145deg, #fff5eb 0%, #ffecd2 25%, #fcb69f 50%, #ee9ca7 75%, #ffdde1 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Noise texture overlay -->
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.4;
            background-image: url('data:image/svg+xml,%3Csvg viewBox=%220 0 256 256%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22/%3E%3C/svg%3E');
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 10%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Checklist content -->
          <div style="padding: 0 10%; position: relative; z-index: 1; flex: 1;">
            <div style="
              font-size: ${titleSize}px;
              font-weight: 700;
              color: #3d2314;
              line-height: 1.2;
              margin-bottom: 28px;
              text-align: center;
            ">${this.data.title}</div>

            <div>
              ${itemsHtml}
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 10%; position: relative; z-index: 1; display: flex; justify-content: center;">
            <span
              style="
                display: inline-block;
                background: rgba(255, 255, 255, 0.6);
                backdrop-filter: blur(8px);
                color: #3d2314;
                font-size: ${chipSize}px;
                font-weight: 600;
                border-radius: 999px;
                padding: 14px 28px;
                letter-spacing: 0.02em;
                box-shadow: 0 4px 20px rgba(61, 35, 20, 0.1);
              "
            >
              ${this.data.chip}
            </span>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped>
</style>

